




























import { Component, Prop, Vue} from 'vue-property-decorator';
import { KNOWLEDGE_CHECK_EVENTS as KCE } from '@/author/constants';
import KnowledgeCheckEvents from '@/author/components/KnowledgeCheckParts/KnowledgeCheckEvents.vue';

@Component
export default class QuizOption extends Vue {
  @Prop() type?: string;
  @Prop() src?: string;
  @Prop() alt?: string;
  @Prop() right?: boolean;
  @Prop() modal?: boolean;

  correctFeedback!: string;
  incorrectFeedback!: string;
  selectedFeedback!: string;
  instantFeedback: boolean = false;
  showFeedback: boolean = false;
  multiple: boolean = false;
  blockDeselection: boolean = false;
  blockChanges: boolean = false;

  selected: boolean = false;
  answer: boolean = false;
  id: string = '';

  public $refs!: {
    wrapper: HTMLElement;
    button: HTMLElement;
  };

  created(){
    KnowledgeCheckEvents.$on(KCE.AFTER_OPTION_MOUNTED, (multiple:boolean)=>{
      this.multiple = multiple;
    });
    KnowledgeCheckEvents.$on(KCE.HAS_LEARN_MORE_CONTENT, this.setBlockDeselection);
    KnowledgeCheckEvents.$on(KCE.HAS_EVALUATED_ANSWER, this.setBlockChanges);
  }

  beforeMount() {
    let parent : any = this.$parent;
    this.correctFeedback = parent.accessibilityCorrectFeedback;
    this.incorrectFeedback = parent.accessibilityIncorrectFeedback;
    this.selectedFeedback = parent.accessibilitySelectFeedback;
    this.instantFeedback = parent.instantFeedback;
    this.showFeedback = parent.showFeedback;
    KnowledgeCheckEvents.$emit(KCE.OPTION_MOUNTED, this);

    this.answer = this.right !== undefined;
    this.id = (this as any)._uid;
    if(this.instantFeedback)
      this.showFeedback = true;

    KnowledgeCheckEvents.$on(KCE.CLEAR_OPTIONS,() => {
      this.handleClearOptions();
    });
  }

  setBlockChanges() {
    this.blockChanges = true;
  }

  setBlockDeselection() {
    this.blockDeselection = true;
    this.instantFeedback = true;
  }

  handleQuizOptionClick() {
    if (this.blockChanges || (this.selected && this.blockDeselection))
      return;
    if(!this.multiple){
      KnowledgeCheckEvents.$emit(KCE.CLEAR_OPTIONS, this);
      this.selected = true;
    } else 
      this.selected = !this.selected;
    
    this.$refs.wrapper.focus();
    KnowledgeCheckEvents.$emit(KCE.OPTION_SELECTED, this);
  }
  
  handleFocus() {
    if(this.$refs.button) {
      const button = this.$refs.button;
      button.classList.contains('focus') ? button.classList.remove('focus') : button.classList.add('focus');
    };
  }

  handleClearOptions() {
    this.selected = false;
  }
  get hasCustomFeedback():boolean{
    return !!this.$slots['feedback'];
  }

  get slot_id(){
    return `id_${this.id}_slot`;
  }

}
